import { Component, OnInit, inject } from '@angular/core';

import { TranslateService } from '@plugins/client/translate/services';
import { setWindowTitleFromJWT } from '@plugins/shared/utils/title-from-jwt';

@Component({
  selector: 'faq-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  protected translateService = inject(TranslateService);
  ngOnInit() {
    setWindowTitleFromJWT();
  }
}
